export default __webpack_public_path__ + "static/media/Skillset.5949d60d.png";